__turbopack_context__.v({
  "Icon": "ibHZHa_Icon",
  "IconCheck": "ibHZHa_IconCheck",
  "Root": "ibHZHa_Root",
  "Root--Added": "ibHZHa_Root--Added",
  "Root--FullWidth": "ibHZHa_Root--FullWidth",
  "Root--Grey": "ibHZHa_Root--Grey",
  "Root--Map": "ibHZHa_Root--Map",
  "Root--Removed": "ibHZHa_Root--Removed",
  "Root--Small": "ibHZHa_Root--Small",
  "Root--TableOfContents": "ibHZHa_Root--TableOfContents",
  "Text": "ibHZHa_Text",
  "skeleton-loading": "ibHZHa_skeleton-loading",
});
